import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ResolvedVideoShare } from '@companion-professional/dctypes';
import { resolveVideoShare } from '../lib/api';

// useVideoShare resolves a share short code to its creation time and list of videos. Pass null/empty to disable the query (e.g. when the
// URL has no code yet). isNotFound is true specifically for a 404, which the endpoint returns for an unknown or expired
// code — that is a normal "nothing to show" state rather than an unexpected failure.
export const useVideoShare = (shortCode: string | undefined) => {
  const { isPending, isError, error, data } = useQuery<ResolvedVideoShare, AxiosError>({
    queryKey: ['videoShare', shortCode],
    queryFn: () => resolveVideoShare(shortCode as string),
    enabled: !!shortCode
  });

  return {
    isPending,
    isError,
    isNotFound: error?.response?.status === 404,
    createdAt: data?.created_at,
    items: data?.items ?? []
  };
};
